module.exports = __webpack_public_path__ + "static/media/project-example-1.4bf86ff6.png";